<template>
  <div>
    <div class="container-fluid">
      <div class="col-12 my-col col-xl col-lg-12 col-sm-12 ">

        <center><h3>Costs and usage overview Payments and Monetisation</h3></center>
        <tls product='Payments'></tls>
        <plutusAkamai />
        <plutusAws />
        <newRelic :accountId='1673697'> </newRelic>
        <plutusLogzio />
      </div>
    </div>      
  </div>
</template>
<script>

import tls from '@/pages/teams/components/tls.vue'
import plutusAws from '@/pages/teams/plutus/aws.vue'
import plutusAkamai from '@/pages/teams/plutus/akamai.vue'
import plutusLogzio from '@/pages/teams/plutus/logzio.vue'
import newRelic from '@/pages/newrelic.vue'
export default {
  components: {
    newRelic,
    plutusAws,
    plutusAkamai,
    plutusLogzio,
    tls,
  },
}
</script>
